/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserEventResponse
 */
export interface UserEventResponse {
    /**
     * 
     * @type {any}
     * @memberof UserEventResponse
     */
    userEventId?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof UserEventResponse
     */
    createdOn?: Date;
    /**
     * 
     * @type {string}
     * @memberof UserEventResponse
     */
    eventDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEventResponse
     */
    createdByDescription?: string | null;
}

/**
 * Check if a given object implements the UserEventResponse interface.
 */
export function instanceOfUserEventResponse(value: object): value is UserEventResponse {
    return true;
}

export function UserEventResponseFromJSON(json: any): UserEventResponse {
    return UserEventResponseFromJSONTyped(json, false);
}

export function UserEventResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEventResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userEventId': json['userEventId'] === undefined ? undefined : json['userEventId'] === null ? null : json['userEventId'],
        'createdOn': json['createdOn'] == null ? undefined : (new Date(json['createdOn'])),
        'eventDescription': json['eventDescription'] === undefined ? undefined : json['eventDescription'] === null ? null : json['eventDescription'],
        'createdByDescription': json['createdByDescription'] === undefined ? undefined : json['createdByDescription'] === null ? null : json['createdByDescription'],
    };
}

export function UserEventResponseToJSON(json: any): UserEventResponse {
    return UserEventResponseToJSONTyped(json, false);
}

export function UserEventResponseToJSONTyped(value?: UserEventResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userEventId': value['userEventId'],
        'createdOn': value['createdOn'] == null ? value['createdOn'] : value['createdOn'].toISOString(),
        'eventDescription': value['eventDescription'],
        'createdByDescription': value['createdByDescription'],
    };
}

